import { Button } from "components/Button";
import { Contact } from "components/Contact";
import { ContentHero } from "components/ContentHero";
import { getDocByUID, getDocs } from "shared/prismic";
import { GREEN } from "shared/variables";
import { MaxWidth } from "components/MaxWidth";
import { Page } from "components/Page";
import { RelatedItemsWrapper } from "components/RelatedItems";
import { Slices } from "components/Slices";
import { SpacingSection } from "components/SpacingSection";
import dynamic from "next/dynamic";

const ShopifyBuyButton = dynamic(() => import("components/ShopifyBuyButton"), {
  ssr: false,
});

export async function getStaticProps({ preview = null, previewData, params }) {
  const doc = await getDocByUID({
    previewData,
    uid: params.uid,
    type: "book_detail",
  });
  return { props: { doc, preview } };
}

export async function getStaticPaths() {
  const pages = await getDocs({ type: "book_detail" });
  const paths = pages.map(({ uid }) => ({ params: { uid } }));
  return { paths, fallback: false };
}

const PageToExport = ({ doc, preview }) => {
  const {
    body,
    contact_email,
    contact_tel,
    contact_title,
    contact_whatsapp,
    external_button_url,
    external_button_label,
    hero_image,
    hero_text,
    hero_title,
    hero_type,
    related_items_title,
    related_items,
    seo_description,
    seo_image,
    seo_title,
    shopify_product_id,
  } = doc.data;

  const renderContact =
    contact_title || contact_email || contact_tel || contact_whatsapp;
  const renderHero =
    hero_type || hero_image?.alt || hero_image?.src || hero_title || hero_text;
  const renderRelated = related_items?.length > 0 || related_items_title;
  const renderSlices = body?.length > 0;

  return (
    <Page
      description={seo_description}
      image={seo_image}
      preview={preview}
      title={seo_title}
      withLightFooter={renderContact && !renderRelated}
    >
      {renderHero && (
        <ContentHero
          image={{ alt: hero_image.alt, src: hero_image.url }}
          text={hero_text}
          title={hero_title}
          type={hero_type}
        />
      )}
      {renderSlices && <Slices data={body} />}
      {shopify_product_id ? (
        <SpacingSection>
          <MaxWidth>
            <ShopifyBuyButton productId={shopify_product_id} />
          </MaxWidth>
        </SpacingSection>
      ) : (
        <ShopifyBuyButton />
      )}
      {external_button_url?.url && (
        <SpacingSection>
          <MaxWidth>
            <Button color={GREEN} link={external_button_url}>
              {external_button_label || "Bekijk in webshop"}
            </Button>
          </MaxWidth>
        </SpacingSection>
      )}
      {renderContact && (
        <Contact
          title={contact_title}
          email={contact_email}
          tel={contact_tel}
          whatsapp={contact_whatsapp}
        />
      )}
      {renderRelated && (
        <SpacingSection>
          <RelatedItemsWrapper
            related_items={related_items}
            related_items_title={related_items_title}
          />
        </SpacingSection>
      )}
    </Page>
  );
};

export default PageToExport;
